import { render } from "./listProduct.vue?vue&type=template&id=162fe618"
import script from "./listProduct.vue?vue&type=script&lang=js"
export * from "./listProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__